<app-reports-header [(startDate)]="startDate" [(endDate)]="endDate" (reportRunChange)="run()" [report]="report"></app-reports-header>
<app-daily-sales-report-chart-header [(loading)]="loading" [(salesSummary)]="salesSummary"></app-daily-sales-report-chart-header>
<app-daily-sales-report-content [(loading)]="loading" [(salesSummary)]="salesSummary"></app-daily-sales-report-content>
